import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const DropdownArrowLeftIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 7.41421C15 6.52331 13.9229 6.07714 13.2929 6.70711L8.70711 11.2929C8.31658 11.6834 8.31658 12.3166 8.70711 12.7071L13.2929 17.2929C13.9229 17.9229 15 17.4767 15 16.5858L15 7.41421Z"
          fill="black"
        />
      </svg>
    )
  },
)
